"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

import {
  identifyAgencyVisitorOnLoad,
  loadAgencyPostHog,
  syncAgencyReplay,
} from "@/lib/posthog-agency";

/** Starts the agency's PostHog after load. Mounted only when the PostHog app
 *  emitted a config, so other storefronts ship none of this. */
export function AgencyPostHog(): null {
  const pathname = usePathname();

  useEffect(() => {
    void loadAgencyPostHog();
  }, []);

  useEffect(() => {
    syncAgencyReplay();
  }, [pathname]);

  return null;
}

/** Account pages: the session already names the guest (AC-10). */
export function AgencyVisitorIdentify({
  email,
  name,
}: {
  email: string;
  name: string | null;
}): null {
  useEffect(() => {
    void identifyAgencyVisitorOnLoad({ email, name });
  }, [email, name]);

  return null;
}
